
window.sswcustom = {
    bind: {
        wishlistIcon: e => {
            const ele = e.currentTarget,
            status = ele.classList.contains("wishlist-added")? "remove" : "add";
            ele.classList.add("wishlist-pending");
            window.sswcustom.addRemoveFave (status, ele.dataset.productId, ele.dataset.params.page, data => {
                if (data.success) {
                    if (status == "remove") {
                        ele.classList.remove("wishlist-added");
                    } else {
                        ele.classList.add("wishlist-added");
                    }
                    window.sswcustom.countFave (function (s) {
                        document.querySelector(".ssw-counter-fave-menu").innerHTML = s.count;
                    });
                }
                ele.classList.remove("wishlist-pending");
            });
        },
        all: e => {
            [...document.querySelectorAll('[data-wishlist-handle]')].forEach (wishlistIcon => {
                wishlistIcon.addEventListener('click', window.sswcustom.bind.wishlistIcon.bind(this))
            });
        }
    },
    addRemoveFave: function (status, productId, page, callback, first_variant_id = 0) {
        let o = JSON.parse(localStorage.getItem("gw_has_guest_wishlist_items")) ?? !0,
        url = status == "remove" ? "/lite2/unfave" : "/lite2/fave",
        d = {
            product_id: productId,
            _sid: window.sswCookie("hesid"),
            hash_key: window.sswCookie("hash_key"),
            has_guest_wishlist_items: o,
            page: page,
            event: "fave",
            first_variant_id: first_variant_id,
            variant_id: 0
        },
        a = $.post(window.sswProxyUrl + url, d, (function(s) {

            callback(s);
        }
        ), "json")
    },
    countFave: function (callback) {
        const s = {
            _sid: $.cookie("hesid"),
            hash_key: $.cookie("hash_key")
        };

        $.post(window.sswProxyUrl + "/lite2/fave-count", s, "json").done((s=>{
            callback(s);
            }
            )).fail((s=>{
                console.log("fave-count fail");
            }
        ))
    },
    getFaves(ids, callback) {
        const t = JSON.parse(localStorage.getItem("gw_has_guest_wishlist_items")) ?? !0
          , a = {
            ids: ids.join("I"),
            _sid: $.cookie("hesid"),
            hash_key: $.cookie("hash_key"),
            has_guest_wishlist_items: t
        };
        $.post(window.sswProxyUrl + "/lite2/feed/getFaves", a, (t=> {
            callback(t);
        }
        ), "json")
    },
    findAllProductIds() {
        return [...document.querySelectorAll(".card-wishlist.wishlist-icon")]
        .map( wishlistIcon => wishlistIcon.dataset.productId);
    },
    updateAllWishlistIcons () {
        const ids = window.sswcustom.findAllProductIds();
        window.sswcustom.getFaves(ids, (data) => {
            let e, a = parseInt(data.fave_with_variant) || 0, i = data.fave_multiple_variant || 0;
            Object.keys(data.viewer_faves).forEach (key => {
                if (data.viewer_faves[key][0] > 0) {
                    if (ids.indexOf(key) >= 0) {
                        document.querySelector('.card-wishlist.wishlist-icon[data-product-id="'+key+'"]')
                        .classList.add("wishlist-added");
                    }
                }
            });
        });
    }
}
